<script>
  import servico from '../servico';
  import AdicionarArquivos from '~componentes/FormAdicionarArquivos.vue';

  export default {
    components: { AdicionarArquivos },
    data() {
      return {
        solicitacao: null,
        carregando: true,
        descricaoAtividade: '',
        configuracao: this.$storage.configuracao(),
      }
    },
    created() {
      this.carregar(this.$route.params.idCript);
    },
    mounted() {
      this.$root.botaoRetrocederMostrar = false;
      this.$root.botaoRetrocederRota = '';
      this.$root.botaoAcaoMostrar = false;
    },
    methods: {
      carregar(id) {
        this.carregando = true;

        servico.obterPorId(id)
          .then(dados => {
            this.solicitacao = dados;
            this.$root.tituloDaPagina = 'Registrar Atividade - Solicitação #' + dados.idSolicitacaoReembolso;
            this.carregando = false;
          });
      },
      tipo(tipoReembolso) {
        if (tipoReembolso === 0) {
          return 'Passagem';
        }
        if (tipoReembolso === 1) {
          return 'Diária';
        }
        return 'Adiantamento';
      },
      salvar() {
        $('#salvar').button('loading');

        this.$validator.validateAll()
          .then(valido => {
            if (!valido) {
              $('#tabs a[href="#tab-descricao-atividade"]').tab('show');
            }
            return valido;
          })
          .then(this.enviar)
          .catch(erro => {
            $('#salvar').button('reset');
            this.$mensagemErro(erro, 'Erro ao registrar atividade.');
          });
      },
      enviar(valido) {
        if (!valido) throw new Error("validacao com erro");

        var id = this.$route.params.idCript;
        var formData = new FormData();
        formData.append('descricaoAtividade', this.descricaoAtividade);

        var arquivos = this.$refs.adicionarArquivos.arquivos;
        for (var i = 0; i < arquivos.length; i++) {
          if (arquivos[i]) {
            formData.append('arquivos', arquivos[i]);
          }
        }

        return servico.salvarAtividade(id, formData)
          .then(() => {
            toastr.success('Atividade registrada com sucesso.');
            this.$router.push({ name: 'solicitacao-reembolso-pf-atividade' });
          });
      },
    },
  }
</script>

<template>
  <div :class="'wrapper wrapper-content animated ' + $root.animacaoPadrao">
    <div class="row">
      <div class="col-xs-12">
        <div class="ibox float-e-margins" v-if="carregando">
          <div class="ibox-content">
            <p class="text-center">
              <i class='fa fa-spinner fa-pulse'></i> Carregando...
            </p>
          </div>
        </div>

        <div class="tabs-container" v-show="!carregando" id="tabs">

          <ul class="nav nav-tabs">
            <li class="active">
              <a data-toggle="tab"
                 href="#tab-dados-solicitacao">
                Dados da solicitação
              </a>
            </li>
            <li>
              <a data-toggle="tab"
                 href="#tab-descricao-atividade">
                Descrição da atividade
              </a>
            </li>
            <li>
              <a data-toggle="tab"
                 href="#tab-adicionar-arquivos">
                Adicionar arquivos
              </a>
            </li>
          </ul>

          <div class="tab-content">

            <div id="tab-dados-solicitacao" class="tab-pane active">
              <div class="panel-body" v-if="solicitacao">
                <div class="row">
                  <div class="col-sm-4">
                    <div class="form-group">
                      <label>Número</label>
                      <input type="text" class="form-control" :value="solicitacao.idSolicitacaoReembolso" disabled>
                    </div>
                  </div>
                  <div class="col-sm-4">
                    <div class="form-group">
                      <label>Tipo</label>
                      <input type="text" class="form-control" :value="tipo(solicitacao.tipoReembolso)" disabled>
                    </div>
                  </div>
                  <div class="col-sm-4">
                    <div class="form-group">
                      <label>Data solicitação</label>
                      <input type="text" class="form-control" :value="$options.filters.formatarNumeroEmData(solicitacao.dataSolicitacao)" disabled>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-sm-6">
                    <div class="form-group">
                      <label>Beneficiário</label>
                      <input type="text" class="form-control" :value="solicitacao.documentoTerceiro + ' - ' + solicitacao.nomeTerceiro" disabled>
                    </div>
                  </div>
                  <div class="col-sm-6">
                    <div class="form-group">
                      <label>Projeto</label>
                      <input type="text" class="form-control" :value="solicitacao.projeto ? solicitacao.projeto.nomeProjeto : ''" disabled>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-sm-12">
                    <div class="form-group">
                      <label>Observação</label>
                      <textarea class="form-control" rows="3" :value="solicitacao.observacao" disabled></textarea>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div id="tab-descricao-atividade" class="tab-pane">
              <div class="panel-body">
                <div class="form-group required" :class="{'has-error': errors.has('descricaoAtividade')}">
                  <label class="control-label">Descrição da atividade</label>
                  <textarea class="form-control"
                            rows="5"
                            v-model="descricaoAtividade"
                            placeholder="Descreva a atividade realizada"
                            data-vv-name="descricaoAtividade"
                            data-vv-as="descrição da atividade"
                            v-validate="'required'"></textarea>
                  <p class="text-danger" v-show="errors.has('descricaoAtividade')">
                    {{ errors.first('descricaoAtividade') }}
                  </p>
                </div>
              </div>
            </div>

            <div id="tab-adicionar-arquivos" class="tab-pane">
              <div class="panel-body">
                <adicionar-arquivos ref="adicionarArquivos"></adicionar-arquivos>
              </div>
            </div>

          </div>

        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-xs-12">
        <div class="form-group">
          <router-link class="btn btn-default"
              :to="{ name: 'solicitacao-reembolso-pf-atividade' }"
             active-class="">
            <i class="fa fa-arrow-left"></i> Voltar
          </router-link>

          <button id="salvar" type="button" class="btn btn-primary"
              @click="salvar" v-show="!carregando"
              data-loading-text="<i class='fa fa-spinner fa-pulse'></i> Salvando...">
            <i class="fa fa-save"></i> Salvar
          </button>
        </div>
      </div>
    </div>
  </div>
</template>



// WEBPACK FOOTER //
// FrontEnd/modulos/solicitacao-reembolso-atividade/componentes/SolicitacaoReembolsoAtividadeForm.vue